export interface ISolarAccountDetailsRequest {
  igsCustomerNumber: string;
}

export class SolarAccountDetailsRequest implements ISolarAccountDetailsRequest {
  igsCustomerNumber: string;

  constructor(igsCustomerNumber?: string) {
    this.igsCustomerNumber = igsCustomerNumber;
  }
}
